import { all, fork } from 'redux-saga/effects';
import { watchAddDocumentFromTemplateSaga } from './add-from-template';
import { watchCreateDocumentTemplateSaga } from './create';
import { watchCreateDocumentTemplatePrivateSectionSaga } from './create-private-section';
import { watchEmbedDocumentTemplateSaga } from './embed';
import { watchFetchDocumentTemplateSaga } from './fetch';
import { watchCreateDocumentTemplateResourceSectionSaga } from './resource-sections/create-resource-section';
import { watchUpdateDocumentTemplateResourceSectionSaga } from './resource-sections/update-resource-section';
import { watchUpdateDocumentTemplateContentSaga } from './sections/update-content';
import { watchCreateDocumentTemplateHighlightTaskSaga } from './tasks/create-highlight-task';
import { watchCreateDocumentTemplateTaskSaga } from './tasks/create-task';
import { watchDeleteDocumentTemplateTaskSaga } from './tasks/delete-task';
import { watchUpdateDocumentTemplateTaskSaga } from './tasks/update-task';
import { watchUpdateDocumentTemplateSaga } from './update';

export function* documentTemplateRootSaga(): Generator {
  yield all([
    fork(watchCreateDocumentTemplateSaga),
    fork(watchEmbedDocumentTemplateSaga),
    fork(watchAddDocumentFromTemplateSaga),
    fork(watchUpdateDocumentTemplateSaga),
    fork(watchUpdateDocumentTemplateContentSaga),
    fork(watchFetchDocumentTemplateSaga),
    fork(watchCreateDocumentTemplateTaskSaga),
    fork(watchUpdateDocumentTemplateTaskSaga),
    fork(watchDeleteDocumentTemplateTaskSaga),
    fork(watchCreateDocumentTemplateResourceSectionSaga),
    fork(watchUpdateDocumentTemplateResourceSectionSaga),
    fork(watchCreateDocumentTemplatePrivateSectionSaga),
    fork(watchCreateDocumentTemplateHighlightTaskSaga),
  ]);
}
